import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import { defineNuxtPlugin } from '#app';
Vue.use(VueCompositionAPI.default || VueCompositionAPI);
export default defineNuxtPlugin(function (nuxtApp) {
  var _originalSetup = nuxtApp.nuxt2Context.app.setup;

  nuxtApp.nuxt2Context.app.setup = function () {
    var result = _originalSetup instanceof Function ? _originalSetup.apply(void 0, arguments) : {};
    var hookResult = nuxtApp.hooks.callHookWith(function (hooks) {
      return hooks.map(function (hook) {
        return hook();
      });
    }, 'vue:setup');

    if (process.dev && hookResult && hookResult.some(function (i) {
      return i && 'then' in i;
    })) {
      console.error('[nuxt] Error in `vue:setup`. Callbacks must be synchronous.');
    }

    return result;
  };
});